<template>
    <Dashboard
        :title="__('Settings')"
    >
        <Heading
            :label="__('Settings', null, $page.props.profile_locale)"
        />
        <form class="grid grid-cols-2 gap-3">
            <InputLabel
                :label="__('Current Password', null, $page.props.profile_locale)"
                id="old_password"
                type="password"
                class="col-span-2"
                v-model="form.old_password"
                autocomplete="old_password"
            />
            <InputLabel
                :label="__('Password', null, $page.props.profile_locale)"
                id="password"
                type="password"
                class="mt-1 block"
                v-model="form.password"
                autocomplete="password"
            />
            <InputLabel
                :label="__('Confirm Password', null, $page.props.profile_locale)"
                id="password_repeat"
                type="password"
                class="mt-1 block"
                v-model="form.password_repeat"
                autocomplete="password_repeat"
            />

            <div class="flex">
                <BreezeButton class="py-2 px-4"
                    @click.prevent="changePassword"
                >
                    {{__('Reset', null, $page.props.profile_locale)}}
                </BreezeButton>
            </div>
        </form>
    </Dashboard>
</template>

<script>
    import Dashboard from '@/Layouts/Dashboard';
    import InputLabel from 'UI/InputLabel';
    import BreezeButton from 'UI/Button';
    import Heading from 'COMP/Heading';

    import { Inertia } from '@inertiajs/inertia'
import { useForm } from '@inertiajs/inertia-vue3';

    export default {
        data() {
            return {
                old_password: null,
                password: null,
                password_repeat: null,
                user: this.$page.props.auth.user
            }
        },
        components: {
            Dashboard, InputLabel, Heading, BreezeButton
        },
        setup(props) {
            const form = useForm({
                old_password: '',
                password: '',
                password_repeat: '',
            })

            function changePassword() {
                form.post("/change/password", {
                    preserveScroll: true,
                    onSuccess: (e) => { form.reset() },
                })
            }

            return {
                form,

                changePassword,
            }
        },

    }
</script>
